import { CommonModule, CurrencyPipe, DatePipe, LowerCasePipe, PercentPipe, UpperCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { ObjectPipe } from './object.pipe';
import { DynamicPipe } from './dynamic.pipe';
import { TimePipe } from './time.pipe';
import { CountPipe } from './count.pipe';
import { SnakeTitlePipe } from './snake-title.pipe';
import { ReactionPipe } from './reaction.pipe';
import { S3VideoPipe } from './s3-video.pipe';
import { SliceTextPipe } from './slice-text.pipe';
import { ActivePipe } from './active.pipe';
import { AntiActivePipe } from './anti-active.pipe';
import { LinkifyPipe } from './linkify.pipe';
import { StatusPipe } from './status.pipe';
import { UserPipe } from './user.pipe';
import { VideoLengthPipe } from './video-length.pipe';
import { ThumbnailPipe } from './thumbnail.pipe';
import { NumberFormatPipe } from './number-format.pipe';
import { PercentFormatPipe } from './percent-format.pipe';
import { AbsPipe } from './abs.pipe';
@NgModule({
	imports: [CommonModule],
	declarations: [PercentFormatPipe, ObjectPipe, DynamicPipe, TimePipe, CountPipe, SnakeTitlePipe, ReactionPipe, S3VideoPipe, SliceTextPipe, ActivePipe, AntiActivePipe, LinkifyPipe, StatusPipe, UserPipe, VideoLengthPipe, ThumbnailPipe, NumberFormatPipe, AbsPipe],
	exports: [PercentFormatPipe, NumberFormatPipe, ActivePipe, AntiActivePipe, ObjectPipe, DynamicPipe, TimePipe, CountPipe, SnakeTitlePipe, PercentPipe, ReactionPipe, S3VideoPipe, SliceTextPipe, LinkifyPipe, StatusPipe, UserPipe, VideoLengthPipe, ThumbnailPipe, AbsPipe],
	providers: [PercentFormatPipe, NumberFormatPipe, ActivePipe, AntiActivePipe, DatePipe, CurrencyPipe, DynamicPipe, ObjectPipe, UpperCasePipe, LowerCasePipe, CountPipe, SnakeTitlePipe, PercentPipe, ReactionPipe, S3VideoPipe, SliceTextPipe, LinkifyPipe, StatusPipe, UserPipe, VideoLengthPipe, ThumbnailPipe, AbsPipe],
})
export class PipesModule {}
